var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPendingOrders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#FFFAF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3241 24.4785C31.8256 24.6871 33.192 25.4576 34.1473 26.6346C35.1027 27.8115 35.5759 29.3071 35.4714 30.8193C35.3668 32.3316 34.6924 33.7479 33.5841 34.7821C32.4759 35.8164 31.0165 36.3916 29.5006 36.3916C27.9848 36.3916 26.5254 35.8164 25.4171 34.7821C24.3089 33.7479 23.6344 32.3316 23.5299 30.8193C23.4253 29.3071 23.8985 27.8115 24.8539 26.6346C25.8093 25.4576 27.1757 24.6871 28.6771 24.4785",
    stroke: "#986600",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4662 38.5283V41.3408H17.5352V38.5283",
    stroke: "#986600",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4631 40.8721V43.7476H19.5371V40.8721",
    stroke: "#986600",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1531 30.8149C39.3196 30.8149 39.4546 30.6799 39.4546 30.5134C39.4546 30.3469 39.3196 30.2119 39.1531 30.2119C38.9865 30.2119 38.8516 30.3469 38.8516 30.5134C38.8516 30.6799 38.9865 30.8149 39.1531 30.8149Z",
    stroke: "#986600",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1485 30.5003C20.1485 30.42 20.1169 30.3428 20.0605 30.2855C20.0041 30.2283 19.9274 30.1955 19.847 30.1943C19.7662 30.1955 19.6891 30.2281 19.6319 30.2852C19.5748 30.3424 19.5422 30.4195 19.541 30.5003C19.5422 30.5807 19.575 30.6574 19.6322 30.7138C19.6895 30.7702 19.7666 30.8018 19.847 30.8018C19.927 30.8018 20.0037 30.7701 20.0602 30.7135C20.1168 30.657 20.1485 30.5803 20.1485 30.5003V30.5003Z",
    stroke: "#986600",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.316 31.706H11.1985C10.3834 31.706 9.6016 31.3821 9.02521 30.8057C8.44881 30.2294 8.125 29.4476 8.125 28.6325V20.3255C8.125 19.5103 8.44881 18.7286 9.02521 18.1522C9.6016 17.5758 10.3834 17.252 11.1985 17.252H47.8015C48.6166 17.252 49.3984 17.5758 49.9748 18.1522C50.5512 18.7286 50.875 19.5103 50.875 20.3255V28.6325C50.875 29.4476 50.5512 30.2294 49.9748 30.8057C49.3984 31.3821 48.6166 31.706 47.8015 31.706H43.684",
    stroke: "#986600",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7734 24.4785H46.2264",
    stroke: "#986600",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3164 24.4785V38.5275H43.6844V24.4785",
    stroke: "#986600",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingOrders);
export default __webpack_public_path__ + "static/media/pending_orders.a6b54dcc37dfef1129082456dc78de3c.svg";
export { ForwardRef as ReactComponent };